import { Skeleton, SxProps } from '@mui/material';
import React from 'react';
import { SkeletonProps } from '@mui/material/Skeleton';

export type CustomSkeletonProps = {
    width?: string | number;
    sx?: SxProps;
    numberOfSkeletons?: number;
}

export default ({ width, sx, numberOfSkeletons = 1 }: CustomSkeletonProps) => {
    return (
        <>
            {Array.from({ length: numberOfSkeletons }).map((_, index) => (
                <Skeleton key={index} width={width} sx={{ ...sx }} />
            ))}
        </>
    );
};
